// extracted by css-extract-rspack-plugin
export default {"CommitSelectorWrapper":"CommitSelector-module__CommitSelectorWrapper__i8V6ctT","CommitSelectorContainer":"CommitSelector-module__CommitSelectorContainer__EWJVSWy"};